import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';

import { DescriptionService, DescriptionData, NotebookNotebook } from './description.service';

@Component({
  selector: 'naas-descriptions',
  templateUrl: './descriptions.component.html',
  styleUrls: ['./descriptions.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class DescriptionsComponent implements OnInit {
  description: DescriptionData;
  notebooks: NotebookNotebook[];
  restricted: boolean;
  scope: string;
  customer: string;

  constructor(
    public httpClient: HttpClient,
    private descriptionService: DescriptionService,
    private route: ActivatedRoute,
  ) {
    const titleService = inject(Title);
    const pageTitle = 'Notebook Descriptions - Noteable';
    titleService.setTitle(pageTitle);

    const myH1 = document.querySelector('h1');
    if (myH1) {
      myH1.textContent = pageTitle;
    }
  }
  ngOnInit() {
    this.route.data.subscribe(data => {
      this.description = data.description;
      // this.notebooks = this.description['notebooks'];
      this.notebooks = this.description['notebooks'].sort((nb1, nb2) => {
        const obj1 = nb1['display_name'].toUpperCase();
        const obj2 = nb2['display_name'].toUpperCase();

        if (obj1 < obj2) {
          return 1;
        }
        if (obj1 > obj2) {
          return -1;
        }
        return 0;
      });
      this.scope = this.description['scope'];
      this.customer = this.description['customer'];
    });
  }
}
